import { FormGroup } from '@angular/forms';
import { FormService } from './../../services/form.service';
import { Component, Input, OnInit, Output, EventEmitter, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { ControlType } from './control-type-enum';
import { SpecialityType } from 'app/services/enum.service';
import {DPGJCModel, DPTModel} from '../../reports/reports-model';
import intlTelInput from 'intl-tel-input';

declare var $: any;

export interface IOptions {
  key: any;
  value: any;
}
export interface Section {
  section: number;
  title: string;

}

export enum SelectType {
  select,
  multipleSelect
}
export enum SelectionChoice {
  add, remove
}
export class SelectDowpdownIdsModel {
  select: string[];
  multipleSelect: string[]
}

export interface SelectedFiles {
  formKey: string;
  selectedFile: string;
}
export class IForm {
  value: any;
  key: string;
  label: string;
  placeholder?: string;
  required: boolean;
  order?: number;
  controlType: ControlType;
  type: string;
  options?: IOptions[];
  hidden?: boolean = false;
  readonly?: boolean = false;
  validators?: any;
  authorSpeciality?: SpecialityType;
  belongTo?: number | number[] | undefined;
  settings? = {};
  nestedKeyForDropdowns?:any;
  accepts?: string;
  changeMethod?(values: any, form: any, key?: string): any;
  position?: string;
  maxDate?: Date;
  message?: string;
  tooltip?: string;
}

@Component({
  selector: 'app-form-component',
  templateUrl: './form-component.component.html',
  styleUrls: ['./form-component.component.scss'],
  standalone: false,
})
export class FormComponentComponent implements OnInit {
  @ViewChild('phoneInput') phoneInputRef: ElementRef;
  iti: any;
  @Input() sections: Section;
  @Input() model: IForm[];
  @Input() title: string;
  @Input() hasSave: boolean;
  @Input() hasDraft: boolean;
  @Input() hasFilter: boolean;
  @Input() hasCancel: boolean;
  @Input() hasModify: boolean;
  @Input() hasDownload: boolean;
  @Input() validateDisabled: boolean;
  @Output() save = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Output() modify = new EventEmitter();
  @Output() draft = new EventEmitter();
  public form: FormGroup;
  protected singleSelect = {};
  public controlType = ControlType;
  public sectionFields: any;
  @Input() dpgjc: DPGJCModel;
  @Input() dpt: DPTModel[];
  public showFileInput = false;
  public selectedFiles: SelectedFiles[] = [];
  @Input() fontSize = 14;
  constructor(private _formService: FormService, private _renderer: Renderer2) { }

  ngOnInit() {
    if (this.sections) {
      this.sectionFields = this.model.filter(field => field.belongTo)
      this.form = this._formService.toFormGroup(this.model);
      this.model = this.model.filter(field => !field.belongTo || (Array.isArray(field.belongTo) && field.belongTo?.includes(0)))
      // Group by section as key to the person array
      this.sectionFields = this.groupBy(this.sectionFields, 'belongTo');
    }
    else {
      this.form = this._formService.toFormGroup(this.model);
    }

    if (this.dpgjc) {
      this.updateValuesByDpgjc();
    }
    if (this.dpt) {
      this.updateValuesByDpt();
    }

    this.singleSelect = {
      singleSelection: true,
      text: "Zgjidh",
      selectAllText: 'Selekto të gjitha',
      unSelectAllText: 'Fshij të gjitha',
      enableSearchFilter: true,
      classes: "cs-dropdown",
      labelKey: "value",
      primaryKey: "key",
      lazyLoading: true
    };
  }

  /*
  * update report fields with values from dpgjc
  */
  protected updateValuesByDpgjc() {
    this.form?.controls.patientsName?.setValue(this.dpgjc.firstname);
    this.form?.controls.patientsSurname?.setValue(this.dpgjc.lastname);
    this.form?.controls.fatherName?.setValue(this.dpgjc.father);
    this.form?.controls.idNumber?.setValue(this.dpgjc.nid);
    this.form?.controls.birthday?.setValue(this.dpgjc.birthdate);
    this.form?.controls.birthPlace?.setValue(this.dpgjc.placeOfBirth);
    this.form?.controls.address?.setValue(this.dpgjc.street);
    this.form?.controls.city?.setValue(this.dpgjc.city);
    this.form?.controls.administrativeUnit?.setValue(this.dpgjc.region);
    this.form?.updateValueAndValidity()
  }
  /*
  * update report fields with values from dpt
  */
  protected updateValuesByDpt() {
    let profesion = '';
    if (this.dpt) {
      let dpt = this.dpt.map(item => item.professionCategory).filter((value, index, self) => self.indexOf(value) === index)
      dpt.forEach(element => {
        profesion += element + ', ';
      });

      this.form?.controls.profession?.setValue(profesion.slice(0, -2));
      this.form?.controls.isInsured?.setValue(true);
      this.form?.updateValueAndValidity()
    }
  }

  ngAfterViewInit(): void {
    this.iti = intlTelInput(this.phoneInputRef.nativeElement, {
      initialCountry: 'al',
      separateDialCode: true,
      autoPlaceholder : "off",
      loadUtils: () => import("../../../assets/js/utils.js"),
    });

    
    $(document).ready(function(){
      $('.collapse').on('show.bs.collapse', function (e) {
          $('.collapse').collapse("hide")
      })
  })
  }

  groupBy(array: any, key: string) {
    return array.reduce((result, currentValue) => {
      if (Array.isArray(currentValue[key])) {
        currentValue[key].forEach(el => {
          if(el != 0) {
            (result[el] = result[el] || []).push(
              currentValue
          );
          }
        })
      } else {
        (result[currentValue[key]] = result[currentValue[key]] || []).push(
            currentValue
        );
      }

      return result;
    }, {}); 
  }

  protected onSave(clearForm: boolean = false) {
    if (clearForm){
      this.form.reset();
    }
    if (this.form.valid) {
      const values = !!this.validateDisabled ? this.form.value : this.form.getRawValue();
      const telValues = this.model.filter(it => it.controlType == ControlType.tel);
      telValues.forEach(element => {
        if(values[element.key]?.length >= 9) {
          const countryData = this.iti.getSelectedCountryData();
          const countryCode = countryData.dialCode;
          values[element.key] = '+'+countryCode+values[element.key]
        } else {
          delete values[element.key];
        }
      });
      const fileKeys = this.findFile();
      if(fileKeys){
        fileKeys.forEach(element => {
          const selectedElement = this.selectedFiles.find(x => x.formKey === element);
          if(selectedElement) {
            var base64 = selectedElement.selectedFile.split(";base64,");
            values[element] = base64[1];
          }
        });
      }
      this.save.emit(values);
    }
    else {
      this.form.markAllAsTouched()
      this.save.emit(null)
    }
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
  }

  protected onCancel() {
    this.cancel.emit(null);
  }

  protected onModify() {
    if (this.form.valid) {
      const values = (this.validateDisabled) ? this.form.value : this.form.getRawValue();
      const telValues = this.model.filter(it => it.controlType == ControlType.tel);
      telValues.forEach(element => {
        if(String(values[element.key])?.length >= 9) {
          const countryData = this.iti.getSelectedCountryData();
          const countryCode = countryData.dialCode;
          values[element.key] = '+'+countryCode+values[element.key]
        } else {
          delete values[element.key];
        }
      });
      const fileKeys = this.findFile();
      if(fileKeys){
        fileKeys.forEach(element => {
          const selectedElement = this.selectedFiles.find(x => x.formKey === element);
          if(selectedElement) {
            var base64 = selectedElement.selectedFile.split(";base64,");
            if(base64?.length > 1) {
              values[element] = base64[1];
            }else {
              delete values[element];
            }
          } else {
            delete values[element];
          }
        });
      }
      this.modify.emit(values);
    } else {
      this.modify.emit(null);
      this.form.markAllAsTouched()
    }
  }

  protected onDraft() {
    const values = (this.validateDisabled) ? this.form.value : this.form.getRawValue();

    if (this.form.valid) {
      this.draft.emit(values);
    } else {
      this.draft.emit(null);
      this.form.markAllAsTouched()
    }
  }

  protected checkArray(values: any[], optionkey: any) {
    if (values) {
      const inArray = values.find(v => v === optionkey);
      if (inArray) {
        return true;
      }
    }
    return null;
  }

  onSearch(event: any, item) {
    event.stopPropagation();
    const searchText = event.target.value.toLowerCase();
    // Filter the options based on the search text
    const filteredOptions = item.options.filter(option =>
        option.value.toLowerCase().includes(searchText)
    );
    // Update the options in the item
    item.filteredOptions = filteredOptions;
  }

  protected findFile() {
    let fileKeys: string[] = [];
    this.model.forEach(element => {
      if (element.controlType == ControlType.file) {
        fileKeys.push(element.key)
      }
    });
    return fileKeys;
  }

  toggleFileInput() {
    this.showFileInput = true;
  }

  async onFileSelected(event, key) {
    if(this.selectedFiles.findIndex(x => x.formKey === key) != -1) {
      const file = this.selectedFiles.find(x => x.formKey === key);
      file.selectedFile = await this.convertToBase64(event.target.files[0] as File);
    } else {
      this.selectedFiles.push({formKey: key, selectedFile: await this.convertToBase64(event.target.files[0] as File)})
    }
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result as string;
        resolve(base64String);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  }

  protected readonly ControlType = ControlType;

  transformDate(date: Date): { year: number, month: number, day: number } {
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,  // Months are zero-indexed in JavaScript
      day: date.getDate()
    };
  }

  
  phoneNumberValidation(formKey: string) {
    if (!!formKey) {
      if (this.iti.isValidNumber()) {
        this.form.get(formKey)?.setErrors(null);
      } else {
        if(this.form.get(formKey)?.value) {
          //if no number make it valid again. Validators is needed only for number
          this.form.get(formKey)?.setErrors({ phoneNotValid: true });
        }
      }
      this.form?.updateValueAndValidity();
    }
}
}
